<template>
  <div class="pc-page">
    <div class="test_main test_main_3">
      <Nav></Nav>
      <div class="test_detail test_3">
        <div class="box">
          <em class="icon part_over"></em>
          <p class="tips" v-if="type!='test'">学习动力测评已完成！</p>
          <div class="btngroup">
            <a class="btn btn_goon" v-if="type!='test'" @click="jump()">点击继续</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import Nav from '../../../../components/learningAbility/learningMotivation.vue';
  export default {
    data() {
      return {}
    },
    mounted() {
      $('.test_menu .item').eq(0).addClass('item_3');
    },
    updated() {
    },
    methods: {
        jump() {
            this.$router.push('/learningAbility/Navgation3')
        }
    },
    components: {Nav},
  }
</script>

